export const MAIN_MOUSE_BUTTON = 0

export const MIDDLE_MOUSE_BUTTON = 1

export const RIGHT_MOUSE_BUTTON = 2

export const BACK_MOUSE_BUTTON = 3

export const FORWARD_MOUSE_BUTTON = 4
